import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import { register } from "./utils/sw";

import { Provider } from "react-redux";
import { store } from "./redux/store";

import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => {
        console.log("Service worker registered.", reg);
      })
      .catch((err) =>
        console.error("Service worker registration failed:", err)
      );
  });
}
